import { useEffect, useState, VFC } from "react";
import { Box, Button, TextField } from "@mui/material";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { TYPES } from "store/types";
import GenericTemplate from "@template/index";
import { getCountHandoverWorkList } from "@api/work";
import { getVehiclesByFrameNo } from "@api/itemReport";
import LoadingOverlayController from "@shared-components/loading/LoadingOverlayController";
import { useHistoryCustom } from "shared/hook/useHistoryCustom";
import LabelRequired from "components/atoms/LabelRequired";
import messages from "config/messages";
import { getUserInfo } from "@utils/index";

const HandoverForkliftReport: VFC = () => {
  // ------------------------------------------------------------------
  // 初期化
  // ------------------------------------------------------------------
  const location = useLocation<any>();
  const template_id = location.state?.template_id;
  const project_id = location.state?.project_id;
  const project_location_id = location.state?.project_location_id;
  const template_project_id = location.state?.template_project_id;
  const handover_key = "vehicles_frame_no";
  const [vehiclesFrameNo, setVehiclesFrameNo] = useState("");
  const [vehicleId, setVehicleId] = useState("");
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [disabledSubmit, setdisabledSubmit] = useState(true);
  const userInfo = getUserInfo();
  const history = useHistoryCustom();
  const dispatch = useDispatch();

  useEffect(() => {
    if (vehiclesFrameNo === "") {
      setdisabledSubmit(true);
    }
  }, [vehiclesFrameNo]);

  // ------------------------------------------------------------------
  // 選択
  // ------------------------------------------------------------------
  const handleSubmit = async () => {
    try {
      LoadingOverlayController.show();
      // 帳票件数をチェック ------------------------------
      let count_handover_work_list = 0;
      let params = {
        SK: project_id,
        project_location_id: project_location_id,
        // year_month: moment().format("YYYY-MM"),
        handover_key: handover_key,
        handover_value: vehiclesFrameNo,
      };
      await getCountHandoverWorkList(params).then((res) => {
        count_handover_work_list = res.data;
      });

      // 画面遷移 ------------------------------
      if (count_handover_work_list === 0) {
        // 0件のとき、新規起票へ遷移
        history.pushWithRef("/work/create", {
          handover_key: "vehicle_id",
          handover_value: vehicleId,
        });
      } else {
        // 1件以上あるとき、引継ぎ帳票選択へ遷移
        dispatch({
          type: TYPES.SET_EACH_FILTER_CONDITION,
          payload: {
            type_screen: "handover_report",
            data: {
              author: [
                {
                  id: userInfo?.SK,
                  name: userInfo?.full_name,
                },
              ],
              location: [],
            },
          },
        });
        const timerId = setInterval(() => {
          if (!LoadingOverlayController.isShowing()) {
            history.pushWithRef("/select-report/handover", {
              template_id,
              project_location_id,
              project_id,
              template_project_id,
              // year_month: moment().format("YYYY-MM"),
              handover_key: "vehicle_id",
              handover_value: vehicleId,
            });
            clearInterval(timerId);
          }
        }, 100);
      }
    } finally {
      LoadingOverlayController.hide();
    }
  };

  // ------------------------------------------------------------------
  // 検索
  // ------------------------------------------------------------------
  const handleVehicleSearch = async (value: string) => {
    try {
      LoadingOverlayController.show();
      // 車体番号検索
      if (value) {
        const response = await getVehiclesByFrameNo({
          activity_base_id: project_location_id,
          frame_no: value,
        });
        if (response.data) {
          setVehiclesFrameNo(value);
          setVehicleId(response.data.SK);
          setErrorMessage("");
          setdisabledSubmit(false); // 選択ボタンを活性
        } else {
          setErrorMessage(messages.COMMON.MSG_NON_SEARCH_RESULT(value));
          setdisabledSubmit(true); // 選択ボタンを非活性
        }
      }
    } finally {
      LoadingOverlayController.hide();
    }
  };

  return (
    <GenericTemplate title={"起票選択"}>
      <Box width={"100%"} sx={{ display: "flex" }}>
        <Box sx={{ display: "flex" }}>
          <TextField
            label={<LabelRequired title={"車体番号"} />}
            value={vehiclesFrameNo}
            onChange={(e) => {
              setVehiclesFrameNo(e.target.value);
              setdisabledSubmit(true);
            }}
            sx={{ flex: 1 }}
            helperText={errorMessage}
            error={errorMessage.length > 0}
          />
          <Box sx={styles.searchBtn}>
            <Button
              sx={{ minWidth: 60 }}
              onClick={() => handleVehicleSearch(vehiclesFrameNo)}
              disabled={vehiclesFrameNo.length == 0}
            >
              検索
            </Button>
          </Box>
        </Box>
      </Box>
      <Box sx={{ display: "flex", mt: 1, justifyContent: "center" }}>
        <Button
          color="secondary"
          onClick={handleSubmit}
          disabled={disabledSubmit}
        >
          選択
        </Button>
      </Box>
    </GenericTemplate>
  );
};

export default HandoverForkliftReport;

const styles = {
  searchBtn: {
    display: "flex",
    alignSelf: "start",
    ml: 1,
    mt: "34px",
  },
};
